import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ClockIcon, HubIcon, ListItemIcon, LoopIcon } from "./icons";

const ICON_MAP = {
  hr: LoopIcon,
  rta: ClockIcon,
  "partner-hub": HubIcon,
  saas: ListItemIcon,
};

export const ApplicationCard = ({ application, name, description, onClick, isSelected, fullWidth }) => {
  const IconComponent = ICON_MAP[application] || LoopIcon;
  const [iconSize, setIconSize] = useState(60);

  useEffect(() => {
    const handleResize = () => {
      setIconSize(window.innerWidth >= 768 ? 60 : 40);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex ${fullWidth ? "flex-row" : "flex-row md:flex-col"} items-center ${fullWidth ? "justify-start" : "justify-start md:justify-center"} gap-4 p-6
        bg-white border border-[#E5E5E5] transition-all
        hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-0
        ${isSelected ? "ring-2 ring-blue-500 ring-offset-0" : ""}
        w-full min-h-[140px] ${fullWidth ? "" : "md:w-[195px]"} ${fullWidth ? "" : "md:h-[122px]"}
      `}
      style={{
        borderRadius: "14px",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10)",
      }}
    >
      <IconComponent 
        size={iconSize} 
        color={isSelected ? "#0580FA" : "#171717"} 
        className="transition-colors flex-shrink-0"
      />
      <div className={`text-left ${fullWidth ? "" : "md:text-center"} flex-1 ${fullWidth ? "" : "md:flex-none"}`}>
        <h3 className="font-semibold text-base text-black mb-1">
          {name}
        </h3>
        <p className="text-sm text-gray-600">
          {description}
        </p>
      </div>
    </button>
  );
};

ApplicationCard.propTypes = {
  application: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

ApplicationCard.defaultProps = {
  isSelected: false,
  fullWidth: false,
};

